module.exports = __webpack_public_path__ + "img/wechat.88fd13c.png";